import { gql } from '@apollo/client'

export const LEADER_ADDRESS_DETAIL_FRAGMENT = gql`
  fragment LeaderAddressDetailFragment on LeaderAddressDetail {
    id
    city
    complement
    country
    countryCode
    fullAddress
    postalCode
    streetAddress
  }
`
